import React from 'react';
import { TablePaginationProps } from './types';

const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  totalRows,
  limit,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalRows / limit);

  return (
    <div className="table-pagination">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="prev-page"
      >
        Previous
      </button>

      <span className="page-info">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="next-page"
      >
        Next
      </button>
    </div>
  );
};

export default TablePagination;
